import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "translation-bar"
};
const _hoisted_2 = {
  class: "ue-translation-btn"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0,
  class: "angent-box chat-box"
};
const _hoisted_5 = {
  class: "blue-txt"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "gray-txt"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name-icon"
}, [/*#__PURE__*/_createTextVNode("U"), /*#__PURE__*/_createElementVNode("span", {
  class: "relative-txt"
}, "座席")])], -1);
const _hoisted_7 = {
  key: 1,
  class: "chat-box"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "gray-txt"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name-icon"
}, [/*#__PURE__*/_createTextVNode("U "), /*#__PURE__*/_createElementVNode("span", {
  class: "relative-txt"
}, "客户")])], -1);
const _hoisted_9 = {
  class: "ke-txt"
};
import { ref, nextTick, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'translationTxt',
  props: {
    openNlsTranslationBarMsg: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  setup(__props) {
    const props = __props;
    const visible = ref(false); //是否可见
    const scrollArea = ref(null);
    const popverShow = async () => {
      if (!visible.value) {
        visible.value = true;
        document.addEventListener('click', clickFun);
      } else {
        visible.value = false;
      }
    };
    const clickFun = async e => {
      await nextTick();
      const pop = document.getElementsByClassName('real-translation-pop')[0];
      const btn = document.getElementsByClassName('ue-translation-btn')[0];
      if (!(pop && pop.contains(e.target)) && !(btn && btn.contains(e.target))) {
        visible.value = false;
      }
    };
    // 监听props变化
    watch(() => props.openNlsTranslationBarMsg, () => {
      // 确保DOM更新后再滚动
      nextTick(() => {
        if (scrollArea.value) {
          scrollArea.value.scrollTop = scrollArea.value.scrollHeight;
        }
      });
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createBlock(_component_el_popover, {
        placement: "bottom",
        visible: visible.value,
        "popper-class": "real-translation-pop",
        width: 646,
        "popper-style": "background:#f5f6fa;padding:16px;border-radius:4px;"
      }, {
        reference: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          onClick: popverShow
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(visible.value ? '收起实时通话' : '展开实时通话'), 1)])])])]),
        default: _withCtx(() => [_createElementVNode("div", {
          ref_key: "scrollArea",
          ref: scrollArea,
          class: _normalizeClass(__props.openNlsTranslationBarMsg.length > 0 ? 'ue-webchatMsgItem' : 'ue-ue-webchatMsgItem-no')
        }, [__props.openNlsTranslationBarMsg.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, "暂无实时通话")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.openNlsTranslationBarMsg, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "message"
          }, [item.side === 'agent' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(item.text), 1), _hoisted_6])) : _createCommentVNode("", true), item.side === 'customer' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, _toDisplayString(item.text), 1)])) : _createCommentVNode("", true)]);
        }), 128))], 2)]),
        _: 1
      }, 8, ["visible"]);
    };
  }
});